module.exports = {
    'ldf_old' : 20,
    'ldf' : 25,
    'ddf' : 5,
    'rdf' : 10,
    'aidf' : 30,
    'remit' : 70,
}